import { rasterSrc } from "@/generated/raster-images";
import { createFileRoute } from "@tanstack/react-router";
import { PageHero, Section } from "@/components/site-blocks";
import { pageSeo } from "@/lib/seo";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    ...pageSeo({
      path: "/privacy",
      title: "Privacy Policy | CRS Energy",
      description: "How CRS Energy collects, uses and protects your personal information under UK GDPR.",
    }),
  }),
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <>
      <PageHero eyebrow="Legal" title="Privacy Policy" description="How CRS Energy collects, uses and protects your personal information." image={rasterSrc("stock/photo-1573164574511-73c773193279")} imageAlt="" />
      <Section>
        <div className="prose max-w-3xl space-y-6">
          
          {[
            { title: "Information we collect", body: "When you submit an enquiry form, postcode check, or contact us by phone or email, we collect the information you choose to provide, typically your name, contact details, postcode, and a description of your enquiry." },
            { title: "How we use it", body: "We use your information solely to respond to your enquiry, deliver any services you request, and meet our legal and contractual obligations. We do not sell or share your data with third parties for marketing." },
            { title: "Your rights", body: "You have the right to access, correct, or request deletion of your personal data at any time. Contact us using the details on our Contact page to exercise these rights." },
            { title: "Cookies", body: "We use a minimal set of essential cookies to keep the website working. We do not use tracking or advertising cookies without your explicit consent." },
            { title: "Contact", body: "Questions about this policy? Get in touch via our Contact page or write to us at our Bridgend office." },
          ].map((s) => (
            <div key={s.title}>
              <h2 className="text-xl font-semibold">{s.title}</h2>
              <p className="mt-2 text-muted-foreground">{s.body}</p>
            </div>
          ))}
        </div>
      </Section>
    </>
  );
}
